import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import DeleteIcon from 'assets/images/delete.png';
import PlusIcon from 'assets/images/icon/PlusIcon';
import PlusIconDark from 'assets/images/icon/PlusIconDark';
import Remove from 'assets/images/icon/Remove';
import axios from 'axios';
import useGetClassData from 'hooks/useGetClassData';
import {
  cloneDeep,
  isEmpty,
} from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {
  useRecoilState,
  useSetRecoilState,
} from 'recoil';
import {
  activeSubmit,
  fireSubmit,
} from 'state';
import styled from 'styled-components';
import {
  DropdownMenu,
  Icon,
} from 'view/components';

import plus from '../../../../../assets/images/plus_s.png';
import useSetHashData from "../../../../../hooks/useSetHashData";
import FileRemoveIcon from "../../../../../assets/images/icon/FileRemoveIcon";
import {fadeIn} from "../../../../../styled/StyledComponent";

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}
interface LearingMaterialProps {
    file?: any;
}

const LearingMaterial: React.FC<LearingMaterialProps> = () => {
    const {
        state: { createId },        
    } = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const { data: classesData, stepData } = useGetClassData(
        createId,
        "getClassLearningMaterialById",
        loading
    );
    const setSubmit = useSetRecoilState(activeSubmit);
    const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);
    const [homeworkTitle, setHomeworkTitle] = useState<string | undefined>("");
    const [homeworkDetails, setHomeworkDetails] = useState<string | undefined>("");
    const [homeworkCompletionTime, setHomeworkCompletionTime] = useState<string | undefined>("");
    const [homeworkFileTitle, setHomeworkFileTitle] = useState<string | undefined>();
    const [syllabusTitle, setSyllabusTitle] = useState("");
    const [practiceFiles, setPracticeFiles] = useState([{ fileName: "", file: null }]);
    const syllabusFileInput = useRef(null);
    const homeworkFileInput = useRef(null);
    const getFormData = (practiceFiles) => {
        const syllabusFile = syllabusFileInput.current?.files?.[0];
        const homeworkFile = homeworkFileInput.current?.files?.[0];
        const formData = new FormData();

        const strData = {
            title:homeworkTitle,
            expectedCompletionTime:homeworkCompletionTime,
            homeworkDetails:homeworkDetails
        }
        console.log("@strData",strData);

        // string
        // homeworkTitle?.trim() && formData.append("title", homeworkTitle);
        // homeworkDetails?.trim() && formData.append("homeworkDetails", homeworkDetails);
        // homeworkCompletionTime && formData.append("expectedCompletionTime", homeworkCompletionTime);

        formData.append('putHomework', JSON.stringify(cloneDeep(strData)));
        // file
        if (syllabusFile) {
            const syllabusBlob = new Blob([syllabusFile], {
                type: syllabusFile.type,
            });
            formData.append("syllabusFile", syllabusBlob, syllabusFile.name);
        }
        if (homeworkFile) {
            const homeworkBlob = new Blob([homeworkFile], {
                type: homeworkFile.type,
            });
            formData.append("homeworkFile", homeworkBlob, homeworkFile.name);
        }
        console.log('object', practiceFiles)
        const copy = cloneDeep(practiceFiles)
        if (copy.length > 0) {
            console.log('copy.length', copy.length)
            copy.forEach((practiceFile) => {
                if (practiceFile.file) {
                    const practiceBlob = new Blob([practiceFile.file], {
                        type: practiceFile.file.type,
                    });
                    formData.append("practiceFile", practiceBlob, practiceFile.file.name);
                }
            });
        };
        return formData;
    };

    const stringData = () => {
        const strData = {
            title:homeworkTitle,
            expectedCompletionTime:homeworkCompletionTime,
            homeworkDetails:homeworkDetails
        }
        const formData = new FormData();
        formData.append('putHomework', JSON.stringify(cloneDeep(strData)));
        // homeworkTitle?.trim() && formData.append("title", homeworkTitle);
        // homeworkDetails?.trim() && formData.append("homeworkDetails", homeworkDetails);
        // homeworkCompletionTime && formData.append("expectedCompletionTime", homeworkCompletionTime);
        return formData;
    }

    const removePractiveFile = async (index) => {
        await classesAPI.deleteClassLearningMaterial(createId,{
            data:{
                "deleteHomeworkFile": false,
                "deleteSyllabusFile": false,
                "practiceFileOrder": [
                  index
                ]
              }
        })     
        .then(res => {
            setLoading(v => !v)
        })
    };

    const deleteSyllabus = async () => {
        await classesAPI.deleteClassLearningMaterial(createId,{
            data:{
                "deleteHomeworkFile": false,
                "deleteSyllabusFile": true,            
              }
        })     
        .then(res => {
            setLoading(v => !v)
        })
    }

    const deleteHomework = async () => {
        await classesAPI.deleteClassLearningMaterial(createId,{
            data:{
                "deleteHomeworkFile": true,
                "deleteSyllabusFile": false,            
              }
        })     
        .then(res => {
            setLoading(v => !v)
        })
    }

    const putLearningMaterial = async (practiceFiles, isString = false) => {
        setLoading(true)
        await classesAPI
            .putClassLearningMaterial(createId, {
                data:isString ? stringData() : getFormData(practiceFiles),
            })
            .then((res) => {
                setLoading(false)
                console.log("suc", res);
            })
            .catch((e) => {
                console.log("failed", e);
            });
    };

    const handlePracticeFileList = (isAdd: boolean, index?: number) => {
        const copyData = cloneDeep(practiceFiles);
        if (isAdd === true) {
            copyData.push({ fileName: "", file: null });
            setPracticeFiles(cloneDeep(copyData));
        } else {
            copyData.splice(index, 1);
            setPracticeFiles(cloneDeep(copyData));
        }
    };

    const checkFileExtension = (fileName: string) => {
        const allowedExtensions =
            /(\.pdf|\.doc|\.docx|\.txt|\.rtf|\.html|\.csv|\.ppt|\.pptx|\.jpeg|\.png|\.gif)$/i;
        if (!allowedExtensions.exec(fileName)) {
            return false;
        }
        return true;
    };

    const isRightFileExtension = (file: any) => {
        const fileName = file?.name;
        if (!fileName) return false;

        const isRight = checkFileExtension(fileName);
        return isRight;
    };
    const handleAddHomeworkFile = () => {
        const file = homeworkFileInput.current?.files?.[0];
        if (!isRightFileExtension(file)) {
            alert("Please upload a file with the right extension");
            return;
        }
        setHomeworkFileTitle(file?.name);
        putLearningMaterial(practiceFiles);
    };

    const handleAddSyllabusFile = () => {
        const file = syllabusFileInput.current?.files?.[0];
        if (!isRightFileExtension(file)) {
            alert("Please upload a file with the right extension");
            return;
        }
        setSyllabusTitle(file?.name);
        putLearningMaterial(practiceFiles);
    };
    console.log("syllabusTitle", syllabusTitle);

    const downloadFile = async () => {
        try {
            const response = await axios.get(stepData?.syllabus?.url, {
                responseType: "blob",
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", syllabusTitle);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };
    const onClickDropdown = (item) => {
        setHomeworkCompletionTime(item);
    };

    useEffect(() => {
        if (stepData !== null) {
            if (stepData?.practiceFile && stepData?.practiceFile?.length !== 0) {
                setPracticeFiles(cloneDeep(stepData?.practiceFile));
            }
            if (stepData?.syllabus?.fileName) {
                setSyllabusTitle(stepData?.syllabus?.fileName || "");
            }
            if (stepData?.homework) {
                setHomeworkTitle(stepData?.homework?.homeworkTitle || "");
                setHomeworkFileTitle(stepData?.homework?.homework?.fileName || "");
                setHomeworkDetails(stepData?.homework?.homeworkDetails || "");
            }
            if (stepData?.homework?.expectedCompletionTime) {
                setHomeworkCompletionTime(stepData?.homework?.expectedCompletionTime || "");
            }
        }
    }, [stepData]);

    // useSetHashData({data:uploadData, method:uploadDetail})

    useEffect(() => {
        setSubmit(!isEmpty(syllabusTitle));
    }, [syllabusFileInput?.current?.value, syllabusTitle]);

    console?.log("stepData learning", stepData);
    console.log("practiceFiles", practiceFiles);
    console.log("syllabusFileInput", syllabusFileInput);
    console.log('homeworkFileTitle', homeworkFileTitle)

    return (
        <Container>
            <Contents>
                <Row
                    display={"flex"}
                    style={{
                        justifyContent: "space-between",
                        width: "100%",
                        alignItems: "center",
                    }}
                    className={"download"}
                >
                    <Col>
                        <FormBox>
                            <dt>
                                Class syllabus <strong>*</strong>
                            </dt>
                        </FormBox>
                    </Col>
                    <Col
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop:0
                        }}
                    >
                        <Browse
                            className={"download"}
                            style={{
                                height: 40,
                                opacity:1,
                                // pointerEvents: stepData?.syllabus?.url ? "all" : "none",
                                marginTop:0,
                                marginBottom:16
                            }}
                        >
                            <PlusIconDark />
                            <span style={{ fontSize: 16 }}>Download</span>
                            {stepData?.syllabus?.url && <a href={stepData?.syllabus?.url}>down</a>}
                        </Browse>
                    </Col>
                </Row>
                <Row display={"flex"}>
                    <FormItem style={{ width: "100%", marginRight: 15 }}>
                        {syllabusFileInput?.current?.files[0] || syllabusTitle !== "" ? (
                            <EditArea>
                                <span>{syllabusTitle}</span>
                                <div
                                    className="delete"
                                    onClick={async () => {
                                        syllabusFileInput.current.value = "";
                                        setSyllabusTitle("");
                                        await deleteSyllabus()
                                    }}
                                >
                                    <FileRemoveIcon/>
                                </div>
                            </EditArea>
                        ) : (
                            <input
                                className="guide"
                                type="text"
                                placeholder="Upload a syllabus so learners can quickly look over the class roadmap"
                            />
                        )}
                    </FormItem>
                    <Browse>
                        <PlusIcon/>
                        <span>Browse</span>
                        <input
                            type="file"
                            onChange={(e) => {
                                handleAddSyllabusFile();
                            }}
                            ref={syllabusFileInput}
                        />
                    </Browse>
                </Row>
                <h3></h3>
                <FormBox
                    className={"practice"}
                >
                    <dt>Practice files</dt>
                </FormBox>

                {practiceFiles?.map((item, index) => {
                    return (
                        <VideoItems className={"practice"} style={{  alignItems: "center" }}>
                            <FormItem style={{ width: "100%", marginRight: 15 }}>
                                {item.fileName !== "" ? (
                                    <EditArea style={{ transform: "translateY(-23px)" }}>
                                        <span>{item?.fileName}</span>
                                        <div
                                            className="delete"
                                            onClick={async () => {
                                                const copyItem = cloneDeep(practiceFiles);
                                                copyItem[index].file = null;
                                                copyItem[index].fileName = "";
                                                setPracticeFiles(cloneDeep(copyItem));
                                                await removePractiveFile(index)
                                            }}
                                        >
                                            <FileRemoveIcon/>
                                        </div>
                                    </EditArea>
                                ) : (
                                    <input
                                        // value={item.title}
                                        value={""}
                                        readOnly={true}
                                        type="text"
                                        placeholder="Upload materials that will help students practice what they’ve learned"
                                    />
                                )}
                            </FormItem>

                            <Browse style={{ marginRight: practiceFiles.length === 1 ? 0 : 15 }}>
                                <PlusIcon/>
                                <span>Browse</span>
                                <input
                                    type="file"
                                    onChange={async (e) => {
                                        console.log("e.target", e.target.value);

                                        if (!isRightFileExtension(e.target.files[0])) {
                                            alert("Please upload a file with the right extension");
                                            return;
                                        }
                                        const copyItem = cloneDeep(practiceFiles);
                                        copyItem[index].file = e.target.files[0];
                                        copyItem[index].fileName = e.target.files[0]?.name;
                                        await setPracticeFiles(cloneDeep(copyItem));
                                        setTimeout(async ()=>{
                                           await putLearningMaterial(cloneDeep(copyItem));
                                        },150)
                                        
                                        e.target.value = "";
                                    }}
                                />
                            </Browse>
                            {practiceFiles?.length !== 1 && (
                                <RemoveButton
                                    className={"removeButton"}
                                    style={{
                                        opacity: practiceFiles.length === 1 ? 0 : 1,
                                        pointerEvents: practiceFiles.length === 1 ? "none" : "all",
                                    }}
                                    onClick={ async () => {
                                        if (practiceFiles.length !== 1) {
                                           
                                            handlePracticeFileList(false, index);
                                          
                                        }
                                        // await removePractiveFile(index)
                                    }}
                                >
                                    <Remove />
                                </RemoveButton>
                            )}
                        </VideoItems>
                    );
                })}

                <AddChapter
                    onClick={() => {
                        handlePracticeFileList(true);
                    }}
                >
                    <span>Add</span>
                    <PlusIcon />
                </AddChapter>
                <Divider />
                <h2 className={"homeworkTitle"}>
                    Homework
                </h2>
                <Row display={"flex"}>
                    <Col style={{ width: "100%", flex: 1 }}>
                        <FormBox>
                            <dt>Title</dt>
                            <dd>
                                <FormBoxItemWrap>
                                    <li>
                                        <FormItem>
                                            <input
                                                type="text"
                                                value={homeworkTitle}
                                                onChange={(e) => {
                                                    setHomeworkTitle(e.target.value);
                                                }}
                                                maxLength={100}
                                                placeholder="Enter a title of the homework"
                                            />
                                            <TextLength>{100 - homeworkTitle.length}</TextLength>
                                        </FormItem>
                                    </li>
                                </FormBoxItemWrap>
                            </dd>
                        </FormBox>
                    </Col>
                </Row>

                <VideoItems>
                    <FormItem
                        style={{ width: "35%", minWidth: "35%", marginRight: 15, }}>
                        <h2>Upload reference file for the homework if desired</h2>
                        {!isEmpty(homeworkFileTitle) ? (
                            <EditArea style={{position:"relative"}}>
                                <span>{homeworkFileTitle}</span>
                                <div
                                    className="delete"
                                    onClick={async () => {
                                        homeworkFileInput.current.value = "";
                                        setHomeworkTitle("");
                                        await deleteHomework()
                                    }}
                                >
                                    <FileRemoveIcon/>
                                </div>
                            </EditArea>
                        ) : (
                            <input type="text"  
                            placeholder="Homework title" 
                            value={homeworkFileTitle} />
                        )}
                     
                    </FormItem>
                    <FormItem
                        className={"homeworkFile"}
                    >
                        <h2>&nbsp;</h2>
                        <Browse style={{ marginRight: 15 }}>
                       
                            <PlusIcon/>
                            <span>Browse</span>

                            <input
                                type="file"
                                onChange={handleAddHomeworkFile}
                                ref={homeworkFileInput}
                            />
                        </Browse>
                    </FormItem>

                    <FormItem style={{ width: "100%" }}
                        className={"expected"}
                    >
                        <h2>Expected completion time</h2>
                        <DropdownMenu
                            items={["10 min", "20 min", "30 min"]}
                            selected={homeworkCompletionTime || ""}
                            altText={"Select completion time"}
                            onClick={onClickDropdown}
                        />
                    </FormItem>
                </VideoItems>
                <Row style={{ marginBottom: 0 }}>
                    <FormBox
                        className={"homeworkDetails"}
                    >
                        <dt>Homework details</dt>
                        <dd>
                            <FormBoxItemWrap>
                                <li>
                                    <FormItem style={{ width: "calc(100%)" }}>
                                        <textarea
                                            style={{ height: 100 }}
                                            placeholder="Enter the details of then homework"
                                            onChange={(e) => {
                                                setHomeworkDetails(e.target.value);
                                            }}
                                            value={homeworkDetails}
                                            maxLength={300}
                                        />
                                        <TextLength>
                                            {300 - homeworkDetails?.length || 300}
                                        </TextLength>
                                    </FormItem>
                                </li>
                            </FormBoxItemWrap>
                        </dd>
                    </FormBox>
                </Row>
            </Contents>
            <ButtonItems justifyContent={"flex-end"}>
                <Browse
                    onClick={() => {
                        putLearningMaterial(practiceFiles, true)
                            .then(res => {
                                navigate("/create/overview",{
                                    state:{
                                        createId:createId
                                    }
                                })
                            })
                    }}
                    className={"prev"} style={{ marginRight: 15, width: 100, height: 40 }}>
                    <span style={{ marginLeft: 0 }}>Previous</span>
                </Browse>
                <button
                    className={`${stepData?.syllabus !== null ? "on" : ""} continue`}
                    onClick={() => {
                        putLearningMaterial(practiceFiles, true)
                        .then(res => {
                            navigate("/create/videos",{
                                state:{
                                    createId:createId
                                }
                            })
                        })
                    }}
                >
                    Continue
                </button>
            </ButtonItems>
        </Container>
    );
};
export default LearingMaterial;

const Container = styled.div`
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    .homeworkTitle{
        padding: 16px 0;
        font-size: 26px;
        font-weight: bold;
        line-height: 26px;
        letter-spacing: 0em;
        text-align: left;
        font-family: "Europa-Regular";
    }
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Contents = styled.div`
    padding: 20px 20px 20px 20px;
    overflow: hidden;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
    &.download{
        margin-bottom: 0;
        height: 40px!important;
    }
    @media screen and (max-width: 768px) {
        &.download{
            flex-direction: row;
            & > div{
                margin-top: 8px;
            }
        }
        flex-direction: column;
        width: 100%;
        & > div{
            width: 100%;
        }
    }

`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
    
`;
const Divider = styled.div`
    width: calc(140%);
    transform: translateX(-20%);
    height: 1px;
    background: #333;
    opacity: 0.3;
`;
const FormBox = styled.dl`
    &.practice{
        margin-bottom: 8px;
        @media screen and (max-width: 768px) {
            margin-bottom: 8px;
            padding-top: 8px;
        }
    }
    &.homeworkDetails{
        
        @media screen and (max-width: 768px) {
            padding-top: 8px;
        }
    }
    > dt {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        /* opacity: 0.8; */
        margin-bottom: 8px;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;
const FormItem = styled.div`
    position: relative;
    transition: all 0.2s;
    h2{
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        /* opacity: 0.8; */
        margin-bottom: 8px;
    }
    @media screen and (max-width: 768px) {
        &.homeworkFile{
            h2{
                display:none;
            }
        }
        &.expected{
            h2{
                margin-top: 23px;
            }
        }
    }
    h2 {
        //
        //margin-bottom: 15px;
        @media screen and (max-width: 768px) {
            margin-bottom: 8px;
        }
    }
    .guide {
        pointer-events: none;
    }

    > input[type="text"],
    select,
    textarea {
        transition: all 0.2s;
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
        transition: all 0.2s;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const EditArea = styled.div`
    position: absolute;
    
    width: 100%;
    height: 100%;
    border: solid 1px #33333360;
    z-index: 2;
    border-radius: 8px;
    padding: 0 15px;
    height: 48px;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    @media screen and (max-width: 768px) {
        position: relative;
        transform: none!important;
    }
    .delete {
   
        path{
            fill: #333;
        }
        cursor: pointer;
        padding: 0 8px 0px 8px;
    }
    span {
        color: #333;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: space-between;
    border-top: solid 1px rgba(51, 51, 51, 0.3);
    button {
        &.continue{
            font-family: Europa-Regular;
            font-size: 18px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            border: solid 1px #ddd;
        }
        transition: all 0.2s;
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        background: #ddd;
        pointer-events: none;
        border: solid 1px #333;
        &.on{
            background: #333;
            color: #fff;
            pointer-events: all;
            border: solid 1px #333;
            &:hover{
                background: #fff;
                color: #333;
            }
        }
    }
`;

const FormItems = styled.div`
    border: solid 1px #33333360;
    border-radius: 15px;
    overflow: hidden;
`;
const FormInner = styled.div`
    padding: 15px 15px 10px 15px;
    position: relative;
`;
const FormItemDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #33333360;
`;
const VideoItemsWrap = styled.div`
    padding: 30px 15px 20px 15px;
    h2 {
        color: "#000";
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
    }
`;
const VideoItems = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 15px;
    position: relative;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        width: 100%;
        &.practice{
            width: calc(100% - 30px);
            margin-bottom: 23px!important;
            .removeButton{
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                svg{
                    width: 20px!important;
                    height: 20px;    
                }
                left: calc(100% + 10px);
                z-index: 999;
            }
        }
        & > div{
            width: 100%!important;
            margin-right: 0!important;
        }
    }
`;
const CheckBox = styled.div`
    display: flex;
    margin-right: 13px;
    align-items: center;
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: solid 1px #333;
    }
`;
const Browse = styled.div`
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    min-width: 120px;
    max-width: 120px;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
    cursor: pointer!important;
    &.prev{
        width: 100px!important;
        max-width: 100px!important;
        min-width: 100px!important;
        padding: 0!important;
    }
    svg{
        width: 16px;
        height: 16px;
        path{
            fill: #333!important;
        }
    }
    &:hover{
        background: #333;
        span{
            color: #fff!important;    
        }
        svg{
            stroke: #fff!important;
            path{
                fill: #fff!important;
            }
        }
    }
    @media screen and (max-width: 768px) {
        width: 100%!important;
        min-width: 100%;
        max-width: 100%;
        min-height: 46px;
        margin-top: 8px;
        &.prev{
            min-width: 120px;
            max-width: 120px;
            margin: 0!important;
        }
        &.download{
       
            height: 36px!important;
            min-height: 36px;
            max-width: 36px;
        }
    }
    span {
        margin-left: 10px;
        font-size: 18px;
        font-family: "Europa";
        font-weight: 400!important;
        color: #333;
        
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0;
        z-index: 3;
    }
    a {
        border: solid 1px #111;
        position: absolute;
        width: 100%;
        height: 100%;
        background: #ddd;
        display: flex;
        opacity: 0;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    right: 0;
    top: 0;
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
const RemoveButton = styled.div`
   

    @media screen and (min-width: 768px) {
        box-sizing: border-box;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: solid 1px rgba(51, 51, 51, 0);
        border-radius: 50%;
        cursor: pointer;
        &:hover {
            border: solid 1px #333;
            border-radius: 50%;

            svg {
                transition: all 0.3s;
                color: #333 !important;
                stroke: #333 !important;

                path {
                    fill: #333 !important;
                    opacity: 1 !important;
                    fill-opacity: 1;
                }
            }
        }
    }
`;

const AddButton = styled.div`
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;

    width: 129px;
`;

const AddChapter = styled.div`
    background: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 106px;
    height: 40px;
    justify-content: center;
    border-radius: 8px;
    margin-top: 15px;
    cursor: pointer;
    border: solid 1px #333;
    transition: all 0.2s;
    span {
        color: #fff;
        font-size: 18px;
        margin-right: 10px;
        font-weight: 400;
    }
    &:hover{
        background: #fff;
        border-color: #333;
        svg{
            path{
                fill: #333;
            }
        }
        span{
            color: #333;

        }
    }
`;

const Transcript = styled.div`
    h3 {
        margin-top: 20px;
        margin-bottom: 14px;
        font-size: 26px;
        font-weight: 700;
    }
`;
